import styled from "styled-components";
import { Link } from "react-router-dom";

export const FooterSection = styled("footer")`
  padding: 4rem 0 3rem;
  background: #f2f6fa;

  @media screen and (max-width: 768px) {
    padding: 2.5rem 0 1.5rem;
  }
`;

export const Title = styled("h4")`
  margin-bottom: 1.5rem;
  color: #0c2e4e;
  font-size: 18px;
  text-transform: capitalize;

  @media screen and (max-width: 768px) {
    margin-top: 2rem;
  }
`;

export const NavLink = styled(Link)`
  display: block;
  margin-bottom: 0.625rem;
  font-size: 1rem;
  transition: all 0.2s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: #1878b8;
  }
`;

export const FooterLink = styled("a")`
  display: block;
  max-width: max-content;
  margin-bottom: 0.75rem;
  color: #54657a;
  font-size: 15px;
  line-height: 1.6;
  transition: color 0.2s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: #1878b8;
  }
`;

export const Para = styled("p")`
  max-width: 280px;
  margin-bottom: 1rem;
  color: #54657a;
  font-size: 14px;
  line-height: 1.7;
`;

export const FormLink = styled("a")`
  display: inline-block;
  margin-bottom: 1.25rem;
  padding-bottom: 2px;
  border-bottom: 1px solid #0c2e4e;
  color: #0c2e4e;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.2s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    border-bottom-color: #30b4fc;
    color: #1878b8;
  }
`;

export const ContactMeta = styled("div")`
  margin-top: 1.25rem;
`;

export const MetaLabel = styled("div")`
  margin-bottom: 0.3rem;
  color: #8496ab;
  font-size: 13px;
`;

export const MetaValue = styled("div")`
  max-width: 280px;
  color: #0c2e4e;
  font-size: 14px;
  line-height: 1.7;
`;

export const Extra = styled("section")`
  position: relative;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-bottom: 2rem;
  background: #f2f6fa;
`;

export const LogoContainer = styled("div")`
  display: flex;
  position: relative;
`;

export const Copyright = styled("div")`
  color: #8496ab;
  font-size: 14px;

  a {
    color: #8496ab;

    &:hover {
      color: #1878b8;
    }
  }

  @media screen and (max-width: 768px) {
    order: 3;
    width: 100%;
    margin-top: 1rem;
    text-align: center;
  }
`;

export const FooterContainer = styled("div")`
  display: flex;
  width: 100%;
  max-width: 510px;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  transition: all 0.1s ease-in-out;

  a {
    &:hover,
    &:active,
    &:focus {
      transform: scale(1.1);
    }
  }

  @media screen and (max-width: 769px) {
    width: auto;
  }
`;

export const ProductSwitch = styled("div")`
  cursor: pointer;
  transition: all 0.1s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    transform: scale(1.1);
  }
`;

export const ProductSwitchContainer = styled("div")`
  display: flex;
  width: 85px;
  justify-content: space-between;
`;
